import { apiCall, ApiConfig } from '../../config/api'
import { getSuppliersAction } from '../actions/SupplierActions'
import { call, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosError, AxiosResponse } from 'axios'
import { supplierActionsTypes } from '../types/supplierActionsTypes'
import { SuppliersEntity } from '../../interfaces/Supplier/Supplier'

export function* getSuppliersAsync() {
  try {
    const { status, data }: AxiosResponse<SuppliersEntity[]> = yield call(
      apiCall,
      'GET',
      `${ApiConfig.SupplierApi}/GetDdlInfo?pageSize=500`
    )
    if (status === 200) {
      yield put(getSuppliersAction(data))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getSuppliersAction([], serverError.message))
  }
}

export function* watchGetSupplierAsync() {
  yield takeEvery(supplierActionsTypes.GET_SUPPLIERS, getSuppliersAsync)
}
